
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

// --- Log Report Thunk ---
export const fetchLogReport = createAsyncThunk(
    'logreport/fetchLogReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/log_All_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);


// --- Redux Slice ---
const LogReportSlice = createSlice({
    name: 'LogReport',
    initialState: {

        // Log Report State
        LogData: [],
        logLoading: false,
        logError: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // --- Log Report Data ---
            .addCase(fetchLogReport.pending, (state) => {
                state.logLoading = true;
                state.logError = null;
            })
            .addCase(fetchLogReport.fulfilled, (state, action) => {
                state.logLoading = false;
                state.LogData = action.payload;
            })
            .addCase(fetchLogReport.rejected, (state, action) => {
                state.logLoading = false;
                state.logError = action.payload;
            });
    }
});

// Export the reducer
export default LogReportSlice.reducer;